import { Button } from "@/components/ui/button";
import { Phone, ArrowRight } from "lucide-react";
import { motion } from "framer-motion";
import { BRAND } from "@/lib/brand";
import { trackPhoneCallLead } from "@/lib/ads";
import { Image } from "@/components/ui/image";

const HERO_IMG = "https://media.base44.com/images/public/6a80a7f0e10008ea488688fc/3950e2307_generated_3a7f9f16.png";

export default function Hero() {
  return (
    <section id="top" className="relative min-h-[100svh] w-full overflow-hidden bg-primary">
      <Image
        src={HERO_IMG}
        alt="Premium bedroom awaiting specialized bed bug treatment"
        fittingType="fill"
        loading="eager"
        fetchpriority="high"
        className="absolute inset-0 h-full w-full"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-primary/85 via-primary/75 to-primary" />
      <div className="absolute inset-0 bg-gradient-to-r from-primary/90 to-transparent" />

      <div className="relative z-10 mx-auto flex min-h-[100svh] max-w-7xl flex-col justify-center px-5 pt-24 pb-28 lg:px-8">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}>
          <div className="mb-6 flex items-center gap-3">
            <span className="h-px w-10 bg-accent" />
            <span className="text-[11px] font-semibold uppercase tracking-[0.28em] text-accent">{BRAND.tagline}</span>
          </div>
          <h1 className="mb-5 font-heading text-sm font-semibold uppercase tracking-[0.22em] text-white/90">Bed Bug Control & Treatment — Vancouver & the Lower Mainland</h1>
          <p className="max-w-4xl font-heading text-5xl font-extrabold leading-[0.98] tracking-tight text-white sm:text-6xl lg:text-7xl xl:text-[5.5rem]">
            BED BUGS AREN'T<br />JUST ANOTHER PEST.
            <span className="mt-2 block text-white/45">SO WE DON'T TREAT THEM LIKE ONE.</span>
          </p>
          <p className="mt-8 max-w-xl text-base leading-relaxed text-white/70 sm:text-lg">
            Specialized bed bug treatment for homes, condos, apartments, hotels and short-term rentals across Vancouver and the Lower Mainland.
          </p>
          <div className="mt-10 flex flex-col gap-3 sm:flex-row sm:items-center">
            <Button asChild size="lg" className="h-12 px-8 text-sm font-semibold tracking-wide bg-accent text-white hover:bg-accent/90">
              <a href="#booking">Book Treatment <ArrowRight className="ml-1 h-4 w-4" /></a>
            </Button>
            <Button asChild size="lg" variant="outline" className="h-12 border-white/30 bg-transparent px-8 text-sm font-semibold tracking-wide text-white hover:bg-white/10 hover:text-white">
              <a href={`tel:${BRAND.phoneTel}`} onClick={trackPhoneCallLead}><Phone className="mr-1.5 h-4 w-4" /> Call Now</a>
            </Button>
          </div>
          <div className="mt-10 flex flex-wrap items-center gap-x-3 gap-y-1 text-[11px] font-medium uppercase tracking-[0.18em] text-white/70">
            <span>Specialized Bed Bug Treatment</span>
            <span className="text-accent">•</span>
            <span>Discreet Service</span>
            <span className="text-accent">•</span>
            <span>Professional Application</span>
          </div>
        </motion.div>
      </div>
    </section>
  );
}